/* eslint-disable @typescript-eslint/type-annotation-spacing */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable no-trailing-spaces */
/* eslint-disable prefer-const */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/semi */
/* eslint-disable max-len */
/* eslint-disable object-shorthand */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';

import { GlobalVariable } from '../global';
import { ItemPreviewPage } from '../item-preview/item-preview.page';
import { OrderPlacedDetailPage } from '../order-placed-detail/order-placed-detail.page';
import { UserApiService } from '../services/user-api.service';
import { TrackOrderPage } from '../track-order/track-order.page';

@Component({
  selector: 'app-recent-fav',
  templateUrl: './recent-fav.page.html',
  styleUrls: ['./recent-fav.page.scss'],
})
export class RecentFavPage implements OnInit {
  segment = 'recent';
  favoriteItems=[]
  recentOrders=[];
  constructor(
    
    public globals: GlobalVariable,
    private alertController: AlertController,
    private router: Router,
    private server:UserApiService,
    private modalController:ModalController,
    
  ) {}

  ngOnInit() {}
  ionViewWillEnter() {
    console.log('entered Recent/fav');
    this.getFavList();
    this.getOrders();
    // this.getRecentOrdersLocal();
  }
  getOrders(){
    this.globals.isDataLoaded=false
    this.server.GetUserOrderPlaced().subscribe(res=>{
      this.globals.isDataLoaded=true

      // console.log(res)
      if(res.success){
      this.recentOrders=res.orders
      console.log('order#');
      
    }
    },err=>{
      this.globals.presentToast('Something went wrong, try again')
      console.log(err)
    })
  }
  getFavList() {
   let items= localStorage.getItem('favItems');
   
        // console.log('favs ',items)
        if (items != null && items!='null') {
          let list = JSON.parse(items);
          this.favoriteItems= list.filter((obj, index, self) =>
          index === self.findIndex((o) => o['id'] === obj['id'])
        );
        localStorage.setItem('favItems',JSON.stringify(this.favoriteItems))
          
          console.log(this.favoriteItems);
        }
      
  }

  removeAllFavorites() {
    this.favoriteItems = this.favoriteItems.filter((item) => item !== item);
    localStorage.setItem('favItems', JSON.stringify(this.favoriteItems))
  }
  async openItem(menuitem){
    this.globals.businessMenuItem=menuitem;
    this.globals.itemDetail=menuitem
 
      const modal = await this.modalController.create({
      component: ItemPreviewPage,
      componentProps: { data: menuitem }
      });
    
      await modal.present();
    
      const data = await modal.onDidDismiss();
      console.log(data)
    
 

    //  this.router.navigate(['/item-preview']);

  }
  segmentChanged(ev: any) {
    console.log('Segment changed', ev);
  }
  openMenu(){
    // this.router.navigate(['/tabs/tabs/menu'])
    if(this.globals.inWeb){
      this.router.navigate(['/order']);

    }
    else{
      this.router.navigate(['/tabs/tabs/menu']);

    }
  }
  async detail(data, time, instructions,schedule_time, res, tot, o_id,p_type,doordash_data) {
        const modal =await this.modalController.create({
          component:OrderPlacedDetailPage,
          componentProps:{data:{ p_type:p_type,data: data, time: time, 
            instructions: instructions, schedule_time: schedule_time, res: res,
             tot: tot, o_id: o_id, doordash_data:doordash_data }}
        })
        return modal.present();
}
   async trackOrder(order){
    console.log(order)
    const modal= await this.modalController.create({
      component:TrackOrderPage,
      cssClass:'trackingModal',
      componentProps:{order:order},
      mode:'ios',
    })
    modal.present();
    modal.onDidDismiss().then(res=>{
      this.getOrders();
    })


  }
}
